import { render, staticRenderFns } from "./approve_former.vue?vue&type=template&id=26409ab0&"
import script from "./approve_former.vue?vue&type=script&lang=js&"
export * from "./approve_former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports